import type { ListRewardFiltersResponse } from "@jti/evo-client";
import type { GetRewardFiltersResponseType } from "@jti/rest-api-types";

export const convertEvoRewardFilters = (evoRewardFilters: ListRewardFiltersResponse): GetRewardFiltersResponseType => {
  const { categories, points, tiers } = evoRewardFilters.data;

  return {
    categories: {
      virtual: {
        subcategories: categories.virtual.subcategories ?? [],
        total: categories.virtual.total ?? 0,
      },
      sensory_experience: {
        subcategories: categories.sensory_experience.subcategories ?? [],
        total: categories.sensory_experience.total ?? 0,
      },
      physical: {
        subcategories: categories.physical.subcategories ?? [],
        total: categories.physical.total ?? 0,
      },
      lottery: {
        subcategories: categories.lottery.subcategories ?? [],
        total: categories.lottery.total ?? 0,
      },
    },
    points: {
      min: points?.min ?? null,
      max: points?.max ?? null,
    },
    tiers: tiers ?? [],
  };
};
